import { DOCUMENT } from '@angular/common';
import { DestroyRef, Directive, ElementRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[sdDraggableScroll]',
  standalone: true,
})
export class DraggableScrollDirective implements OnInit {
  @Input() readonly isNotDraggable = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private destroyRef: DestroyRef,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    if (this.isBrowser() && this.el && !this.isNotDraggable) {
      const container = this.el.nativeElement;

      const mouseDown$ = fromEvent<MouseEvent>(container, 'mousedown');
      const mouseMove$ = fromEvent<MouseEvent>(this.document, 'mousemove');
      const mouseUp$ = fromEvent<MouseEvent>(this.document, 'mouseup');

      mouseDown$
        .pipe(
          map((event) => ({
            startX: event.clientX,
            scrollLeft: container.scrollLeft,
          })),
          switchMap((start) =>
            mouseMove$.pipe(
              map((moveEvent) => {
                const deltaX = moveEvent.clientX - start.startX;
                const newScrollValue = start.scrollLeft - deltaX;

                return newScrollValue;
              }),
              takeUntil(mouseUp$),
            ),
          ),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe((scrollValue) => {
          this.renderer.setProperty(container, 'scrollLeft', scrollValue);
        });
    }
  }

  private isBrowser(): boolean {
    return !!(this.document && this.document.defaultView);
  }
}
